import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import ToolSection from 'bundles/widget-simulator/components/tools/ToolSection';
import CourseScopeEditor from 'bundles/widget-simulator/components/tools/scope/CourseScopeEditor';
import PluginScopeEditor from 'bundles/widget-simulator/components/tools/scope/PluginScopeEditor';

import _t from 'i18n!nls/widget-simulator';

import 'css!./__styles__/ScopeEditor';

class ScopeEditor extends React.Component {
  renderHelp() {
    return (
      <div>
        <p>
          <FormattedHTMLMessage
            message={_t(
              `
                These values specify the namespaces for your stored values (
                <code>SET_STORED_VALUES</code> and <code>GET_STORED_VALUES</code>
                ).
              `
            )}
          />
        </p>
        <p>
          <FormattedHTMLMessage
            message={_t(
              `
                Plugins with the same <code>COURSE</code> scope act like plugins in the same course.
              `
            )}
          />
        </p>
        <p>
          <FormattedHTMLMessage
            message={_t(
              `
                Plugins with the
                same <code>PLUGIN</code> scope
                act like instances of the same plugin asset (different items, questions, etc using the same plugin).
              `
            )}
          />
        </p>
        <p>
          <FormattedHTMLMessage
            message={_t(
              `
                Plugins with the same <code>INSTANCE</code> scope act like the same instance of a plugin asset.
              `
            )}
          />
        </p>
        <p>
          <FormattedHTMLMessage
            message={_t(
              `
                On the Coursera platform, these values will be set automatically.
              `
            )}
          />
        </p>
      </div>
    );
  }

  render() {
    return (
      <ToolSection className="rc-ScopeEditor" name={_t('Scope')} help={this.renderHelp()}>
        <p className="hint caption-text">{_t('Set the namespace for stored values.')}</p>
        <CourseScopeEditor />
        <PluginScopeEditor />
      </ToolSection>
    );
  }
}

export default ScopeEditor;
